import { render, staticRenderFns } from "./DashbordDropdownItem.vue?vue&type=template&id=0a76447e&scoped=true&"
import script from "./DashbordDropdownItem.vue?vue&type=script&lang=js&"
export * from "./DashbordDropdownItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a76447e",
  null
  
)

export default component.exports